import { createContext } from 'react';
import { Product } from 'shared/types/product/Product';

export interface ProductDetailsProps {
  product: Product | any;
  productData: any;
  initialColor: any;
  setInitialColor: any;
  initialSize: any;
  setInitialSize: any;
  globalAddToCart: any;
  setGlobalAddToCart: any;
  setGlobalSizeAndWidthGroup: any;
  widgetData: any;
  globalSizeAndWidthGroup: any;
  isMailOrderProduct?: any;
  isCompleteOutOfStock?: boolean;
  webAccountId: string;
  globalPersonalize: any;
  setGlobalPersonalize: any;
  isCreditCustomer: boolean;
  categoryName: string;
  setCategoryName: any;
  isPersonalizeEligible: boolean;
  setIsPersonalizeEligible: any;
  isPersonalizeMandatory: boolean;
  setIsPersonalizeMandatory: any;
  isPersonalizeOptionSelected: boolean;
  setIsPersonalizeOptionSelected: any;
  skuToRulesObject: any;
  initialArrivalDate: string;
  setInitialArrivalDate: any;
  getArrivalDate: any;
}

const ProductContext = createContext<ProductDetailsProps>({
  product: null,
  productData: null,
  initialColor: '',
  setInitialColor: '',
  initialSize: '',
  setInitialSize: '',
  globalAddToCart: () => {},
  setGlobalAddToCart: () => {},
  globalPersonalize: () => {},
  setGlobalPersonalize: () => {},
  widgetData: null,
  setGlobalSizeAndWidthGroup: null,
  globalSizeAndWidthGroup: null,
  isCreditCustomer: false,
  webAccountId: '',
  isCompleteOutOfStock: false,
  categoryName: '',
  setCategoryName: () => {},
  isPersonalizeEligible: false,
  setIsPersonalizeEligible: () => {},
  isPersonalizeMandatory: false,
  setIsPersonalizeMandatory: () => {},
  isPersonalizeOptionSelected: false,
  setIsPersonalizeOptionSelected: () => {},
  skuToRulesObject: '',
  initialArrivalDate: '',
  setInitialArrivalDate: () => {},
  getArrivalDate: () => {},
});

export { ProductContext };
